import { ELIGIBILITY_ERROR_CODES, useRulesEngine } from '@/modules/rulesEngine';

import { InsuranceTerminatedTemplate } from './components/InsuranceTerminatedTemplate';
import { RecordsNotFoundTemplate } from './components/RecordsNotFoundTemplate';
import { EmptyProgramScreen } from './EmptyProgramScreen';

// Terminal eligibility-failure screen, mirroring Sparta's NotEligibleContainer
// (`sparta/src/user/containers/NotEligibleContainer`). A thin switch over the
// soft-failure `code` on the eligibility result — each variant is its own
// component:
//
//   • Eligibility_Terminated      → InsuranceTerminatedTemplate  (IneligibleInsurancePage)
//   • Eligible_User_Not_Qualified → EmptyProgramScreen           (EmptyProgramPage / fallback markdown)
//   • anything else               → RecordsNotFoundTemplate      (RecordsNotFoundPage)
//
// The not-qualified case shares EmptyProgramScreen with the post-survey empty
// catalog (Sparta's EmptyProgramContainer is reached from both paths too).
// Routing into this screen is decided by `shouldRouteToNotEligible` (the ZIP
// field-set + a recognized failure code); the code then selects the variant.
export function NotEligibleScreen() {
  const { eligibilityCheckResult } = useRulesEngine();
  const code = eligibilityCheckResult?.code;

  if (code === ELIGIBILITY_ERROR_CODES.ELIGIBILITY_TERMINATED) {
    return <InsuranceTerminatedTemplate />;
  }

  if (code === ELIGIBILITY_ERROR_CODES.ELIGIBLE_USER_NOT_QUALIFIED) {
    return <EmptyProgramScreen />;
  }

  return <RecordsNotFoundTemplate />;
}
